import {
  HostedIntegrationPage,
  HostedIntegrationPageProps,
} from "~/pages/integrations/hosted-integrations";

const HostedIntegrationEntryPage = ({ scope }: HostedIntegrationPageProps) => {
  return <HostedIntegrationPage {...{ scope }} />;
};

export default HostedIntegrationEntryPage;
